import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Lock, Mail } from 'lucide-react';

const ComingSoonPage: React.FC = () => {
  const { logout } = useAuth();

  return (
    <div style={{ maxWidth: 440, margin: '48px auto 0', textAlign: 'center' }}>
      <div className="pk-i-plate" style={{ width: 56, height: 56, borderRadius: '50%', margin: '0 auto 20px' }}>
        <Lock size={24} />
      </div>

      <h1 className="pk-h2" style={{ marginBottom: 16 }}>Private Beta Access Required</h1>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 24 }}>
        <p className="pk-body">The AskArc API Portal is currently in private beta.</p>
        <p className="pk-sub">We are gradually rolling out access to ensure the best experience for all users.</p>
      </div>

      <div className="pk-card" style={{ textAlign: 'left', marginBottom: 24 }}>
        <h3 className="pk-h4" style={{ marginBottom: 6 }}>Request Early Access</h3>
        <p className="pk-small" style={{ marginBottom: 10 }}>Interested in getting early access to the API portal?</p>
        <a href="mailto:support@fenxlabs.ai?subject=API Portal Beta Access Request" className="pk-btn-text">
          <Mail size={13} /> Contact our team
        </a>
      </div>

      <button type="button" onClick={logout} className="pk-btn pk-btn-outline pk-btn-block">
        Sign Out
      </button>
    </div>
  );
};

export default ComingSoonPage;
